import { Component, OnInit } from '@angular/core';
import { InfoBannerComponent } from "./components/info-banner/info-banner.component";
import { ActivatedRoute } from '@angular/router';
import { SearchBarProductsComponent } from "./components/search-bar-products/search-bar-products.component";
import { ListProductsComponent } from "./components/list-products/list-products.component";
import { ListCategoriesComponent } from "./components/list-categories/list-categories.component";
import { ArrowBackComponent } from "../../shared/components/arrow-back/arrow-back.component";
import { CommentsEstablishmentComponent } from "./components/comments-establishment/comments-establishment.component";

@Component({
  selector: 'features-establishment-main',
  imports: [InfoBannerComponent, SearchBarProductsComponent, ListProductsComponent, ListCategoriesComponent, ArrowBackComponent, CommentsEstablishmentComponent],
  templateUrl: './establishment-main.component.html',
  styleUrl: './establishment-main.component.css'
})
export class EstablishmentMainComponent implements OnInit {
  isClosed: boolean = false;
  currentFilter: any = null;
  establishmentId: string | null = null;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.establishmentId = params['id'];
      // console.log('EstablishmentMainComponent - ID del restaurante:', this.establishmentId);
    });
  }

  onEstablishmentStatusChange(isOpen: boolean): void {
    this.isClosed = isOpen;
  }

  onFilterChanged(filterEvent: any): void {
    this.currentFilter = filterEvent;
    // console.log('Filter changed in main component:', filterEvent);
  }
}
